












import { Component } from 'vue-property-decorator';

import PriceBlock from '@/components/PriceBlock.vue';
import fontSizePropValidator from '@/lib/fontSizePropValidator';

import ProductFeature from './ProductFeature';

@Component({
  components: {
    PriceBlock,
  },
  props: {
    size: {
      type: String,
      default: 'medium',
      validator: fontSizePropValidator,
    },
  },
})
export default class PriceFeature extends ProductFeature { }

